import PublicLayout from '../../components/public/PublicLayout';
import SEO from '../../components/SEO';
import { Link } from 'react-router-dom';
import {
  Music,
  CalendarDays,
  FileAudio,
  Link2,
  Phone,
  Send,
  Disc3,
  Headphones,
  Sparkles,
  CheckCircle2,
  ArrowRight,
} from 'lucide-react';

const PUBLIC_BASE = (() => {
  const h = window.location.hostname;
  return h === 'impink.co.kr' || h === 'www.impink.co.kr' ||
    h === 'urpink.co.kr' || h === 'www.urpink.co.kr' ||
    h === 'localhost' || h === '100.68.115.13' || h === '100.116.73.97' ? '' : '/public';
})();

const STEPS = [
  {
    icon: Music,
    title: '앨범(곡) 소개',
    desc: '발매할 앨범 또는 곡에 대한 간단한 소개를 적어주세요. 장르, 분위기, 콘셉트 등 자유롭게 설명해 주시면 됩니다.',
    color: 'from-violet-500 to-purple-600',
    bg: 'bg-violet-500/10',
    text: 'text-violet-400',
    border: 'border-violet-500/20',
  },
  {
    icon: CalendarDays,
    title: '발매 희망 일정',
    desc: '원하시는 발매 시기를 알려주세요. 예) 3월 초, 4월 중순, 5월 말 등 대략적인 일정이면 충분합니다.',
    color: 'from-sky-500 to-cyan-600',
    bg: 'bg-sky-500/10',
    text: 'text-sky-400',
    border: 'border-sky-500/20',
  },
  {
    icon: FileAudio,
    title: '음원 파일 첨부',
    desc: '데모, 믹스, 마스터링 등 작업 단계에 관계없이 현재 가지고 계신 음원을 MP3 파일로 첨부해 주세요. (최대 10MB)',
    color: 'from-emerald-500 to-teal-600',
    bg: 'bg-emerald-500/10',
    text: 'text-emerald-400',
    border: 'border-emerald-500/20',
  },
  {
    icon: Link2,
    title: '기존 발매 이력',
    desc: '이전에 발매하신 앨범이 있다면 스트리밍 플랫폼 링크를 함께 보내주세요. 처음 발매하시는 경우에는 생략하셔도 괜찮습니다.',
    color: 'from-amber-500 to-orange-600',
    bg: 'bg-amber-500/10',
    text: 'text-amber-400',
    border: 'border-amber-500/20',
  },
  {
    icon: Phone,
    title: '연락처',
    desc: '담당자가 연락드릴 수 있도록 전화번호를 남겨주세요. 빠르고 정확한 상담을 위해 꼭 필요한 정보입니다.',
    color: 'from-rose-500 to-pink-600',
    bg: 'bg-rose-500/10',
    text: 'text-rose-400',
    border: 'border-rose-500/20',
  },
];

function PublicInquiryPage() {
  return (
    <PublicLayout>
      <SEO
        title="유통문의"
        description="음원 유통에 대해 문의하세요."
        path="/inquiry"
      />
      {/* ── 히어로 섹션 ── */}
      <section className="relative overflow-hidden">
        <div className="absolute inset-0 bg-gradient-to-br from-sky-600/20 via-violet-600/10 to-transparent" />
        <div className="absolute inset-0 bg-[radial-gradient(ellipse_80%_50%_at_50%_-20%,rgba(120,119,198,0.15),transparent)]" />
        <div className="absolute top-20 left-10 w-72 h-72 bg-sky-500/10 rounded-full blur-3xl" />
        <div className="absolute bottom-0 right-10 w-96 h-96 bg-violet-500/10 rounded-full blur-3xl" />

        <div className="relative max-w-4xl mx-auto px-4 sm:px-6 pt-16 pb-12 sm:pt-24 sm:pb-16 text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 bg-sky-500/10 border border-sky-500/20 rounded-full text-sky-400 text-xs font-medium mb-6">
            <Sparkles size={13} />
            Distribution Inquiry
          </div>
          <h1 className="text-3xl sm:text-5xl font-extrabold text-white mb-4 leading-tight">
            당신의 음악,<br className="sm:hidden" />{' '}
            <span className="bg-gradient-to-r from-sky-400 to-violet-400 bg-clip-text text-transparent">
              세상에 들려주세요
            </span>
          </h1>
          <p className="text-slate-400 text-base sm:text-lg max-w-2xl mx-auto leading-relaxed mb-8">
            p!nk와 함께라면 음원 유통이 쉬워집니다.<br />
            아래 양식을 작성해 주시면 담당자가 빠르게 연락드리겠습니다.
          </p>

          <div className="flex items-center justify-center gap-4 text-slate-600 mb-6">
            <Disc3 size={28} className="animate-[spin_8s_linear_infinite]" />
            <Headphones size={24} />
            <Music size={22} />
          </div>
          {/* 탭 */}
          <div className="flex items-center justify-center gap-2">
            <Link
              to={`${PUBLIC_BASE}/inquiry`}
              className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-medium transition-colors bg-sky-500/20 text-sky-400 border border-sky-500/30">
              <Headphones size={14} />
              유통안내
            </Link>
            <Link
              to={`${PUBLIC_BASE}/proposal`}
              className="flex items-center gap-1.5 px-4 py-2 rounded-xl text-sm font-medium transition-colors bg-white/[0.04] text-slate-400 border border-white/[0.08] hover:bg-white/[0.08]">
              <Send size={14} />
              유통제안
            </Link>
          </div>
        </div>
      </section>

      {/* ── 유통제안 CTA 카드 ── */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 -mt-2 mb-12">
        <div className="relative overflow-hidden rounded-2xl bg-gradient-to-r from-sky-600 to-violet-600 p-[1px]">
          <div className="rounded-2xl bg-[#0f1a2e] px-6 sm:px-10 py-8 sm:py-10">
            <div className="flex flex-col sm:flex-row items-center gap-6">
              <div className="w-16 h-16 rounded-2xl bg-gradient-to-br from-sky-500 to-violet-500 flex items-center justify-center shrink-0 shadow-lg shadow-sky-500/25">
                <Send size={28} className="text-white" />
              </div>
              <div className="text-center sm:text-left flex-1 min-w-0">
                <p className="text-slate-400 text-sm mb-1">온라인으로 간편하게</p>
                <p className="text-white text-xl sm:text-2xl font-bold tracking-wide">
                  유통제안 바로 접수하기
                </p>
              </div>
              <Link
                to={`${PUBLIC_BASE}/proposal`}
                className="inline-flex items-center gap-2 px-6 py-3 bg-gradient-to-r from-sky-500 to-violet-500 hover:from-sky-400 hover:to-violet-400 rounded-xl text-white font-semibold text-sm transition-all shadow-lg shadow-sky-500/25">
                <Send size={16} />
                제안하기
                <ArrowRight size={16} />
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* ── 필수 내용 안내 카드 ── */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 mb-12">
        <div className="text-center mb-10">
          <h2 className="text-white text-2xl sm:text-3xl font-bold mb-3">
            이런 내용을 알려주세요
          </h2>
          <p className="text-slate-500 text-sm sm:text-base">
            아래 5가지 항목을 포함해 작성해 주시면 더 빠른 상담이 가능합니다.
          </p>
        </div>

        <div className="grid gap-4">
          {STEPS.map(
            ({ icon: Icon, title, desc, color, bg, text, border }, i) => (
              <div
                key={title}
                className={`group relative rounded-2xl bg-[#131e33] border ${border} hover:border-opacity-50 p-6 sm:p-7 transition-all duration-300 hover:translate-x-1`}>
                <div className="flex items-start gap-5">
                  <div className="relative shrink-0">
                    <div
                      className={`w-12 h-12 rounded-xl ${bg} flex items-center justify-center transition-transform group-hover:scale-110`}>
                      <Icon size={22} className={text} />
                    </div>
                    <span
                      className={`absolute -top-2 -right-2 w-5 h-5 rounded-full bg-gradient-to-br ${color} text-white text-[10px] font-bold flex items-center justify-center shadow-lg`}>
                      {i + 1}
                    </span>
                  </div>
                  <div className="min-w-0">
                    <h3 className="text-white font-semibold text-base mb-1.5 flex items-center gap-2">
                      {title}
                      <CheckCircle2
                        size={14}
                        className={`${text} opacity-0 group-hover:opacity-100 transition-opacity`}
                      />
                    </h3>
                    <p className="text-slate-400 text-sm leading-relaxed">
                      {desc}
                    </p>
                  </div>
                </div>
              </div>
            ),
          )}
        </div>
      </section>

      {/* ── 하단 CTA ── */}
      <section className="max-w-4xl mx-auto px-4 sm:px-6 mb-16 text-center">
        <Link
          to={`${PUBLIC_BASE}/proposal`}
          className="inline-flex items-center gap-2 px-8 py-3.5 bg-gradient-to-r from-sky-500 to-violet-500 hover:from-sky-400 hover:to-violet-400 rounded-xl text-white font-semibold text-sm transition-all shadow-lg shadow-sky-500/25">
          <Send size={16} />
          유통제안 하러 가기
          <ArrowRight size={16} />
        </Link>
      </section>
    </PublicLayout>
  );
}

export default PublicInquiryPage;
